import { render, staticRenderFns } from "./ClientGroupsListFilters.vue?vue&type=template&id=61ca5264&"
import script from "./ClientGroupsListFilters.vue?vue&type=script&lang=js&"
export * from "./ClientGroupsListFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClientGroupsListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports